"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getObjectTypeName = void 0;

function getObjectTypeName(objectType) {
  if (!objectType) return "null object";
  if (objectType.name) return objectType.name;
  if (objectType.constructor && objectType.constructor.name) return objectType.constructor.name;
  return "unknown type";
}

exports.getObjectTypeName = getObjectTypeName;